import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginTemplateComponent } from '../../../shared/login-template/login-template.component';
import { GoogleSsoButtonComponent } from '../../../shared/google-sso-button/google-sso-button.component';
import { RouterLink } from '@angular/router';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    LoginTemplateComponent,
    GoogleSsoButtonComponent,
    RouterLink,
    PayeeButtonComponent,
    TranslateModule,
  ],
})
export class LoginComponent {
  get googleSSOUrl(): string {
    return `${environment.baseUrl}/api/auth/sso/google/redirect`;
  }
}
